import type { DestinoId } from "@/routes/routeConfig";

export type IconName = DestinoId | "clientes" | "agencia-equipo" | "mas" | "buscar" | "plegar";

const PATHS: Record<IconName, string> = {
  inicio: "M4 11l8-7 8 7 M6 10v10h12V10 M10 20v-6h4v6",
  leads: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M4 21a8 8 0 0 1 16 0",
  citas: "M4 6h16v14H4z M4 10h16 M8 3v4 M16 3v4",
  whatsapp: "M4 20l1.3-3.9A8 8 0 1 1 8 19z M9 10h6 M9 13.5h4",
  experiencias: "M4 5h16v14H4z M4 16l4.5-4.5 3.5 3.5 3-3 5 5 M15.5 9.5h.01",
  propuestas: "M8 3h8v4H8z M8 5H5v16h14V5h-3 M8 13l3 3 5-6",
  campanas: "M4 20V4 M4 5h13l-3 5 3 5H4",
  resultados: "M4 20V10 M10 20V4 M16 20v-7 M4 20h16",
  fisicas: "M4 4h7v7H4z M13 4h7v7h-7z M4 13h7v7H4z M14 14h2v2h-2z M18 18h2v2h-2z M14 18h2 M18 14h2",
  landings: "M3 5h18v14H3z M3 9h18 M7 13h6 M7 16h4",
  conexiones: "M9 7V3 M15 7V3 M7 7h10v4a5 5 0 0 1-10 0z M12 16v5",
  equipo: "M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M3 20a6 6 0 0 1 12 0 M16 5.2a3 3 0 0 1 0 5.6 M17 14a6 6 0 0 1 4 6",
  ajustes: "M4 7h16 M4 17h16 M8 4v6 M16 14v6",
  clientes: "M4 4h7v7H4z M13 4h7v7h-7z M4 13h7v7H4z M13 13h7v7h-7z",
  "agencia-equipo": "M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M3 20a6 6 0 0 1 12 0 M16 5.2a3 3 0 0 1 0 5.6 M17 14a6 6 0 0 1 4 6",
  mas: "M5 12h.01 M12 12h.01 M19 12h.01",
  buscar: "M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14z M20 20l-4-4",
  plegar: "M5 5v14 M10 12h9 M14 8l-4 4 4 4",
};

/** Vocabulario local de iconos de línea (sin fuente de iconos ni dependencia extra). Siempre decorativos: el texto va al lado. */
export function NavIcon({ name, size = 20 }: { name: IconName; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={name === "mas" ? 3 : 1.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d={PATHS[name]} />
    </svg>
  );
}
